<template>
    <div class="web-wechat-pay-code-box">
        <van-popup :value="showWebWechatPayCode" class="web-wechat-pay-code" @click-overlay='clickOverlay'>
            <div class="web-wechat-code">
                <qrcode id='qrImg' tag="img" :options="{size: 320, padding: 40}" :value="webWechatPayCodeValue" ></qrcode>
            </div>
            <div class="web-wechat-note-1" @click="clickOverlay">
                <p>>>已完成支付，点击查看报告</p>
            </div>
            <div class="web-wechat-note">
                <i class="iconfont icon-wechat"></i>微信扫码付款<span class="web-wechat-num">￥{{webWechatPayPrice}}</span>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    name: 'WebWechatPayCode',
    computed: {
        showWebWechatPayCode() {
            return this.$store.state.pay.showWebWechatPayCode;
        },
        webWechatPayCodeValue() {
            return this.$store.state.pay.webWechatPayCodeValue;
        },
        webWechatPayPrice() {
            return this.$store.state.pay.webWechatPayPrice;
        }
    },
    methods: {
        clickOverlay() {
            this.$store.state.pay.showWebWechatPayCode = false;
            this.$bus.emit('cancelPayReport');
            
            var detailInfo = this.$store.state.report.detailInfo;
            // 更新测验报告数据
            if(detailInfo) {
                this.$store.dispatch('report/updateReportInfo', detailInfo.id);
            }
            // 更新ai状态
            this.$store.state.detail.personInfo.ai = 1;
            this.$store.dispatch('record/updateRecordListAIStatus', {
                id: detailInfo.id
            });

        }
    }
}
</script>